import type {Props} from '../types/types';
import * as React from 'react';
import {View} from '../libs/WebComponents';

const AnimView = (props: Props)=>{

   if (!props) props = {};
   props = {
      style:null,
      duration:300,
      delay:10,
      iterationCount:1,
      animation:'',
      children:null,
      easing:'linear',
      className:'',
      ...props
   };

   const [animate,setAnimate] = React.useState('');
   let timeout;
   React.useEffect(()=>{
      timeout = setTimeout(()=>{
         setAnimate('animatable');
      },props.delay);
      return ()=>{clearTimeout(timeout);};
   },[props.animation]);

   return <View className={props.className+' animatable '+ props.animation+ ' '+animate} style={{display:'flex',flexDirection:'column',...props.style, transition: props.duration+'ms all '+props.easing, animationDuration:props.duration+'ms',animationTimingFunction:props.easing,animationIterationCount:props.iterationCount}}>{props.children}</View>;
};

const Animatable = {
   View:AnimView
};

export default Animatable;
